export enum WalletDisplayTypeId {
  Hidden = 0,
  Barcode = 1,
  Link = 2,
  Text = 3,
  BarcodeText = 4,
}
